module.exports = __webpack_public_path__ + "img/DE05907.8112ddf6.png";